import {createStyles} from '@mantine/core';
import React from 'react';

import {ScratchPlateViewer} from 'notebook/integrations/plate-maps/scratch-plates/ScratchPlateViewer';
import useFilledScratchPlateData from 'notebook/integrations/plate-maps/scratch-plates/useFilledScratchPlateData';
import getTestProps from 'test/lib/cypress/getTestProps';

interface ScratchPlateViewerPaneProps {
  scratchPlateId: string;
  /** Size the viewer to its content instead of filling its parent. */
  contentHeight?: boolean;
}

const useStyles = createStyles((_, {contentHeight}: {contentHeight: boolean}) => ({
  wrapper: {
    width: '100%',
    height: contentHeight ? 'auto' : '100%',
    // PlateMapView sets minWidth inline on the .plate-map SVG, so !important is
    // needed to let the embedded viewer shrink to fit the narrow right sidebar.
    '.plate-map': {
      minWidth: '0 !important',
      width: '100%',
    },
    '.plate-map-legend': {
      width: '100%',
    },
  },
}));

export default function ScratchPlateViewerPane({
  scratchPlateId,
  contentHeight = false,
}: ScratchPlateViewerPaneProps): JSX.Element {
  const {classes} = useStyles({contentHeight});
  const {result} = useFilledScratchPlateData(scratchPlateId);

  return (
    <div
      className={classes.wrapper}
      {...getTestProps({component: 'ScratchPlateViewerPane', element: 'root'})}
    >
      <ScratchPlateViewer result={result} />
    </div>
  );
}
